/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = SKUSplittingDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SKUSplittingDetailsEditor extends _Ext.ItemGridEditor<SKUSplittingDetailsRow> {
        

        protected getColumnsKey() { return "Inventory.SKUSplittingDetails"; }
        protected getDialogType() { return SKUSplittingDetailsDialog; }
        protected getLocalTextPrefix() { return SKUSplittingDetailsRow.localTextPrefix; }
        protected form: SKUSplittingDetailsForm;
        radRowSelection: Serenity.GridRadioSelectionMixin;
        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        // #endregion

        static Items: any[];
        static LineNo: number[];


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e)); 
        }
        protected createToolbarExtensions() { super.createToolbarExtensions(); this.radRowSelection = new Serenity.GridRadioSelectionMixin(this); }
        protected getSlickOptions(): Slick.GridOptions {
            var opt: Slick.GridOptions = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slickgrid-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns(); 
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            columns.push(
                {
                    field: 'Generate SKU',
                    name: '',
                    format: ctx => '<a class="inline-action add-button gen-sku" href="#"><span></span>Genrate SKU</a>',
                    width: 90,
                    minWidth: 90,
                    maxWidth: 90
                }); 
            //To Add Delete Button on Item Row
            columns.push({
                field: 'Print SKU',
                name: '',
                format: ctx => '<a class="inline-action print-row" title="print">' +
                    '<i class="fa fa-print"></i></a>',
                width: 90,
                minWidth: 90,
                maxWidth: 90
            });
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
             

            var item = this.itemAt(row);
            var target = $(e.target);
            (this.parentDialog as SKUSplittingDialog).ItemSelected = item;
            (this.parentDialog as SKUSplittingDialog).setCommonGridData(item.ItemsDetails);
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);


                    });
                    this.view.refresh();
                }

                if (target.hasClass('gen-sku')) {
                    //set items on dialog open 
                    let recordId = item[this.getIdProperty()];//get id
                    this.editItem(recordId);//set as edit
                }
                this.view.refresh();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    //item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    //item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    //item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    //item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    //item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    //item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    //item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    //item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    //item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    //if (item.WstPer != null) {
                    //    item.WstWt = item.NetWeight * (item.WstPer / 100);
                    //}
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            //// *** Calculate Wastage ***
            //if (field === fld.WstPer && value >= 0) {
            //    item.WstWt = item.NetWeight * (value / 100);
            //    item[field] = value;
            //}

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Stock.StockSKUGrid;
            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {


                    var filters: _Ext.SelectGridFilters = {
                        HasBom:true
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = []; 
                        var deptId = this.DeptId;
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Stock.StockItemRow) {


                            let Ledgername;

                            OMS.AccountLedgerService.Retrieve({ EntityId: value.PartyId }, response => Ledgername = response.Entity.LedgerName, { async:false })

                            var ItemDetails = [];

                            var purchase: SKUSplittingDetailsRow = {
                                ProductId: value.ProductId,
                                AttributeId: value.AttributeId,
                                Line_No: value.Line_No,
                                PartyId: value.PartyId,
                                SKU: value.SKU,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                UnitRate: value.Rate,
                                //  UnitLabour: LaborRate,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                NetAmount: value.Rate, 
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                KaratId: value.KaratId,
                                MetalId: value.MetalId,
                                MetalColorId: value.MetalColorId,
                                //BOMDetails: bomdetails,
                                //  LaborDetails: labordetail,
                                CompanyId: companyId,
                                CostMethodId: value.CalcOnId,
                                RefVoucherId: value.VoucherTypeId,
                                RefTransTypeId: value.VoucherTypeId,
                                ItemsDetails: ItemDetails,
                                StockId: value.StockId,
                                HasBom: value.HasBom,
                                LotNo: value.LotNo,
                                CertificateNo: value.CertificateNo,
                                Lab: value.Lab,
                                BagNo: value.BagNo,
                                GroupId: 0,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                GrossAmount: value.CalcOnId == 3 ? value.Rate * value.Pieces : value.Rate * value.Weight,
                                Studded: value.Studded,
                                HSN: value.HSN,
                                TaxCode: value.TaxCode,
                                DesignId: value.DesignId,
                                RefNo: value.RefNo,
                                ProductSizeId: value.ProductSizeId,
                                Purity: value.Purity,
                                PureWeight: value.PureWeight,
                                LedgerName: Ledgername,

                            };
                            orddetails.push(purchase);
                        });                         
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(orderDetail);
                        }

                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });


            //var btnAdd = Q.first(buttons, x => x.cssClass == "add-button");

            //btnAdd.onClick = e => { this.addButtonClick(); };
             
            return buttons;
        }
        //Set Data when values changed in the Common Editor of Master Dialog
        setNewData(lineno: any, productid: any, attributeid: any, sku: string, newitems: SKUItemsRow[]) {
            //this.view.setItems([]);
            var olditem = this.view.getItems().filter(x => x.ProductId == productid && x.AttributeId == attributeid && x.Line_No == lineno && x.SKU == sku)[0];
            var row = this.id(olditem);
            if (olditem != undefined) {
                for (var i = 0; i < newitems.length; i++)
                    olditem.ItemsDetails.push(newitems[i]);
                this.view.updateItem(row, olditem)
            }
        }


        // #endregion
    }
}